<template>
  <div class="vh-flex">
    <NumberOptionField class="ops-item" name="译文字体大小" optionWidth="60px" :value="translateSize" :options="fontSizeOptions" @changeValue="changeTranslateSize"></NumberOptionField>
    <NumberOptionField class="ops-item" name="音标字体大小" optionWidth="60px" :value="symbolSize" :options="fontSizeOptions" @changeValue="changeSymbolSize"></NumberOptionField>
    <NumberOptionField class="ops-item" name="拼写字体大小" optionWidth="60px" :value="textSize" :options="fontSizeOptions" @changeValue="changeTextSize"></NumberOptionField>
  </div>
</template>

<script>
import NumberOptionField from '@/components/NumberOptionField.vue'

import spellConfig from '@/commom/config/SpellConfig'
export default {
  name: 'SpellFontSizeConfig',
  components: {
    NumberOptionField
  },
  props: {
    
  },
  data(){
    return {
        config:null,
        translateSize:0,
        symbolSize:0,
        textSize:0,
        fontSizeOptions:[
            "20px",
            "24px",
            "30px",
            "36px",
            "45px",
            "50px"
        ]
        
    }
  },
  ///挂载完成
  mounted:function(){
    this.config = spellConfig.getConfig()
    this.translateSize = this.config.font.translateSize
    this.symbolSize = this.config.font.symbolSize
    this.textSize = this.config.font.textSize



  },
  methods:{
    ///改变译文字体大小
    changeTranslateSize:function(val){
        this.translateSize = val
        this.config.font.translateSize = val
        spellConfig.saveConfig()
    },
    ///改变符号字体大小
    changeSymbolSize:function(val){
        this.symbolSize = val
        this.config.font.symbolSize = val
        spellConfig.saveConfig()
    },
    ///改变文字字体大小
    changeTextSize:function(val){
        this.textSize = val
        this.config.font.textSize = val
        spellConfig.saveConfig()
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ops-item{
    margin-bottom: 15px;
}
</style>
